const initLegendsCounter = () => {
	const legends = document.querySelectorAll('.location__legend-number');
	if (legends.length > 0) {
		legends.forEach((legend, index) => {
			legend.textContent = index + 1;
		});
	}
};

export default initLegendsCounter;
